import styled from 'styled-components';

import {
  borderRadius8,
  standardFocusState,
} from 'approot/shared/styles/borders.style';
import { rem } from 'approot/shared/style';
import { grey1 } from 'approot/shared/styles/colours.style';
import { spacing4 } from 'approot/shared/styles/spacing.style';

export const MultipleChoiceEditImage = styled.div`
  position: absolute;
  left: ${rem(spacing4)};
  right: ${rem(spacing4)};
  bottom: ${rem(spacing4)};
  top: ${rem(spacing4)};
`;

export const MultipleChoiceEditImageButton = styled.button`
  background-color: ${grey1};
  border: none;
  border-radius: ${rem(borderRadius8)};
  position: absolute;
  padding: 0;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;

  ${standardFocusState}

  &:hover {
    cursor: pointer;
  }
`;

export const MultipleChoiceEditImageUpload = styled(MultipleChoiceEditImage)`
  & > div {
    height: 100%;
  }
`;
